import { Breadcrumb, Button } from "pepsico-ds";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SummaryField } from "../../../components/jsonForms/summaryField/SummaryField";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { paths } from "../../../routes/paths";
import { getDateWithFormat } from "../../../utils/commons";
import { formatCampaignType } from "../../../utils/formatters";
import { getCampaignTitleShort } from "../../../utils/historyLogUtils";
import "./HistoryLogsDetailPage.scss";

export default function HistoryLogsDetailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(GlobalConfigContext) || {};
  const { programTimezone = "UTC" } = context;
  const dataReceived = location?.state?.data;

  // Extract campaign title short using utility function
  const campaignTitleShort = getCampaignTitleShort(dataReceived?.entity);
  const navigateToHistoryLogs = () => {
    // Check if the user came from the content tab
    const fromContentTab =
      location.pathname?.includes("content") ||
      location.state?.from === "content" ||
      (typeof document !== "undefined" &&
        document.referrer?.includes("history-logs-content"));

    if (fromContentTab) {
      // Navigate back to the content tab
      navigate(`/${paths.system_setting}/${paths.history_logs}-content`);
    } else {
      // Navigate back to the campaigns tab
      navigate(`/${paths.system_setting}/${paths.history_logs}`);
    }
  };

  return (
    <div className="container">
      <div className="wrap">
        <Breadcrumb
          breadcrumbs={[
            {
              label: "System Setting",
              href: `../../../${paths.system_setting}`,
            },
            {
              label: "History Logs",
              href: `../../../${paths.system_setting}/${paths.history_logs}`,
            },
            {
              label: dataReceived?.title || "History Logs",
            },
          ]}
          activeIndex={1}
        />
        <div className="history-log-details-container">
          <div className="card">
            <h3>Update Details</h3>
            <SummaryField data={dataReceived?.note} label="What's updated" />
            <div className="flex">
              <SummaryField
                data={getDateWithFormat(
                  dataReceived?.eventDate || "-",
                  programTimezone,
                  "DD/MM/YYYY hh:mm A"
                )}
                label="Updated Time"
              />
              <SummaryField data={dataReceived?.user?.userName} label="Updated By" />
            </div>
            <SummaryField
              data={dataReceived?.changeMade}
              label="Reason for Update"
            />

            {/* {dataReceived?.difference && dataReceived.difference.length > 0 && (
              <DifferenceDisplay differences={dataReceived.difference} />
            )} */}
          </div>
          <div className="card">
            <h3>
              {dataReceived?.entity?.type?.charAt(0)?.toUpperCase() +
                dataReceived?.entity?.type?.slice(1)}{" "}
              Info
            </h3>
            <div className="flex">
              <SummaryField
                data={dataReceived?.entity?.name}
                label={
                  dataReceived?.entity?.type?.charAt(0)?.toUpperCase() +
                  dataReceived?.entity?.type?.slice(1) +
                  " Name"
                }
              />
              <SummaryField
                data={formatCampaignType(dataReceived?.entity?.subType)}
                label={
                  dataReceived?.entity?.type?.charAt(0)?.toUpperCase() +
                  dataReceived?.entity?.type?.slice(1) +
                  " Type"
                }
              />
            </div>

            {dataReceived?.entity?.type === "campaign" && (
              <div className="flex">
                <SummaryField
                  data={campaignTitleShort}
                  label="Campaign Short Name"
                />
                <SummaryField data={dataReceived?.entity?.id} label="Campaign Id" />
              </div>
            )}
          </div>
        </div>
        <div className="button-container">
          <Button
            size="medium"
            text="Close"
            variant="secondary"
            className="mr-2"
            onClick={navigateToHistoryLogs}
          />
        </div>
      </div>
    </div>
  );
}
